import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../Components/Layout';
import Sidebar from '../../Dashboard/Component/Siderbar';
import Breadcrumb from '../Component/Breadcrumb';
import axios from 'axios';
import DataTable from "react-data-table-component";
import { MdOutlineCancel } from "react-icons/md";
import { TiTick } from "react-icons/ti";
import { FaRegClock } from "react-icons/fa";
import { IoListCircleOutline } from "react-icons/io5";
import config from '../../../config';
import { useCurrency } from '../../../context/CurrencyContext';
import { getPrice } from '../../../services/priceUtils';

export default function List() {
    const [history, setHistory] = useState([]);
    const [data, setData] = useState([]);
    const [deleteId, setDeleteId] = useState(null);
    const navigate = useNavigate();
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const { selectedCurrency } = useCurrency();
    const [formattedBalance, setFormattedBalance] = useState('0.00');
    const isOwner = userData.user.isOwner;

    const fetchHistory = async () => {
        try {
          const response = await axios.get(
            `${config.API_BASE_URL_V1}agency/wallet-history`,
            {
              headers: {
                Authorization: `Bearer ${userData.token}`,
                "Content-Type": "application/json",
              },
            }
          );

          console.log('Response: ',response)
          setHistory(response.data.data.history);
          setData(response.data.data.wallet);
        } catch (error) {
          console.error("Error fetching agencies:", error);
        }
    };

    useEffect(() => {
        fetchHistory();
    },[])

    useEffect(() => {
        const updateBalance = async () => {
            if (data.balance > 0) {
                try {
                    const formattedAmount = await getPrice(data.balance, userData.token, selectedCurrency);
                    setFormattedBalance(formattedAmount);
                } catch (error) {
                    console.error("Error updating balance:", error);
                }
            }
        };

        updateBalance();
    }, [selectedCurrency, data.balance, userData?.token]);

    console.log('history: ',history)


    const columns = [
        {
          name: "ID",
          selector: (row) => row.id,
          sortable: true,
          width: "70px",
        },
        {
          name: "Transaction Type",
          selector: (row) => row.type,
          sortable: true,
          width: "150px",
          cell: (row) => (
            <div
              style={{
                backgroundColor: row.type === "decrease" ? "red" : "green",
                color: "white",
                padding: "5px 10px",
                borderRadius: "5px",
                textAlign: "center",
                fontWeight: "bold",
                minWidth: "80px",
              }}
            >
              {row.type}
            </div>
          ),
        },
        {
          name: "Description",
          wrap: true,
          cell: (row) => <p className="text-capitalize">{row.description?.toLowerCase()}</p>,
        },
        {
          name: "Amount",
          selector: (row) => `${row.amount.toFixed(2)} EUR`,
          sortable: true,
          width: "120px",
        },
        {
            name: "Balance After Transaction",
            selector: (row) => `${row.balanceAfterTransaction.toFixed(2)} EUR`,
            sortable: true,
            width: "180px",
            cell: (row) => (
                <div>
                    {isOwner && (
                        <p>{row.balanceAfterTransaction.toFixed(2)} EUR</p>
                    )}
                    {
                        !isOwner && (
                            <p>********</p>
                        )
                    }
                </div>
            )
        }
      ];

return (
<Layout>
    <Breadcrumb title="Credit Management" />
    <div className="content">
        <div className="container">
            <div className="row">
                <Sidebar>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex flex-row" style={{ justifyContent:'space-between' }}>
                                <div className="card booking-header col-xl-6">
                                    <div className="card-body header-content d-flex align-items-center justify-content-between flex-wrap gap-2">
                                        <div>
                                            <h6 className="mb-1">Credit History</h6>
                                        </div>
                                    </div>
                                </div>

                                {isOwner && (
                                <div className="col-xl-5">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <span style={{ backgroundColor:'green' }} className="avatar avatar-xl rounded-circle me-3">
                                                    <TiTick className='fs-36'/>
                                                </span>
                                                <div>
                                                    <h3> {formattedBalance} {selectedCurrency} </h3>
                                                    <p>Credit</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )}
                            </div>

                            <div className="card hotel-list" style={{ boxShadow:'0px 4px 24px 0px rgba(194, 194, 194, 0.25)' }}>
                                <div className="card-body p-0">
                                    <div className="list-header d-flex align-items-center justify-content-between flex-wrap">
                                        <h6 className=""></h6>
                                    </div>

                                    <div className="custom-datatable-filter table-responsive">
                                        <div>
                                            <DataTable
                                                columns={columns}
                                                data={history}
                                                pagination
                                                highlightOnHover
                                                striped
                                                responsive
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {history.length === 0 && (
                                <div style={{ padding:'50px' }} className="d-flex justify-content-center align-items-center">
                                    <p style={{ textAlign: 'center', margin:'auto', width:'100%' }}>No transaction history available.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </Sidebar>
            </div>
        </div>
    </div>
</Layout>
)
}
